import { post,get,getJ,put,deleteJ,getExcel,uploadFile,uploadSort,upload,postOther,getPDF,deletes,importExcel } from '@/utils/axios'
import  baseURL  from '@/utils/axios/axios'
import store from '../store'

export default {
    // 新增角色
    addRole(datas){
        return post('Admin/CreateRole',datas)
    },
    // 编辑角色
    editRole(datas){
        return post('Admin/UpdateRole',datas)
    },
    // 删除角色
    delRole(datas){
        return deleteJ('Admin/DeleteRole',datas)
    },
    // 角色列表
    roleList(datas){
        return get('Admin/QueryRole',datas)
    },



    // 创建作业机构
    CreateMechanism(datas){
        return post('Admin/MechanismAdd',datas)
    },
    // 修改作业机构
    UpdateMechanism(datas){
        return post('Admin/MechanismEdit',datas)
    },
    // 删除作业机构
    deleteMechanism(datas){
        return post('Admin/MechanismDel',datas)
    },
    // 作业机构列表
    QueryMechanism(datas){
        return get('Admin/MechanismList',datas)
    },
   
    
        
    // 创建后台用户
    CreateUser(datas){
        return post('Admin/CreateUser',datas)
    },
    // 修改后台用户
    UpdateUser(datas){
        return post('Admin/UpdateUser',datas)
    },
    // 查询后台用户
    QueryUsers(datas){
        return get('user/selectByPage',datas)
    },



    // 角色权限关联
    // 根据角色查询权限
    queryRoleResource(datas){
        return get('Admin/queryPermission/'+datas)
    },
    // 修改角色菜单
    updatePermission(datas){
        return post('Admin/UpdatePermission',datas)
    },



    // 菜单管理
    //创建后台资源
    createResource(datas){
        return post('Admin/CreateResource',datas)
    },
    //删除资源
    deleteResource(datas){
        return deleteJ('Admin/DeleteResource',datas)
    },
    //获取所有菜单资源
    queryResource(datas){
        return get('Admin/QueryResource',datas)
    },
    //修改权限
    updateResource(datas){
        return post('Admin/UpdateResource',datas)
    },
    
    // 创建角色菜单
    createPermission(datas){
        return post('Admin/CreatePermission',datas)
    },
}